import { takeEvery, put, select } from 'redux-saga/effects';
import { get } from 'lodash';
import chatConsts from '../../chatConnection/constants';
import { consts as userCommunities } from '../userCommunities';
import { currentLocationSelector } from '../../common/selectors';
import { COMMUNITIES, MY_COMMUNITIES } from '../../../constants/routes';
import { consts as postsList } from '../postsList';
import { consts as currentCommunity } from '../currentCommunityInfo';
import { consts as notificationCounters } from '../notificationCounters';
import { consts as removeNotificationsCounters } from '../removeNotificationsCounters';
import { currentCommunityScrollSelector } from '../selectors/currentCommunity';
import { consts as addTemporaryPosts } from '../currentCommunityScrollStatus';

function* newPostNotificationWorker(action) {
  const message = get(action.payload, 'message');
  const communityId = get(message, 'payload.data.communityId');
  const post = get(message, 'payload.data.post');
  const newPost = { ...post, isNewPost: true };
  const currentLocation = yield select(currentLocationSelector);
  const isCurrentCommunity = !!currentLocation.match(
    `/${COMMUNITIES}/${communityId}`,
  );
  const isScrolled = yield select(currentCommunityScrollSelector);

  if (currentLocation === `/${COMMUNITIES}/${MY_COMMUNITIES}`) {
    yield put({
      type: userCommunities.UPDATE_TOTAL_UNREAD_COUNT,
      payload: { communityId, updatePostCounter: true },
    });
  } else if (isCurrentCommunity) {
    if (isScrolled) {
      yield put({
        type: addTemporaryPosts.ADD_TEMPORARY_POST_LIST,
        payload: [newPost],
      });
    } else {
      yield put({
        type: postsList.ADD_NEW_POST,
        payload: [newPost],
      });
    }
    yield put({
      type: currentCommunity.UPDATE_POSTS_COUNTER,
    });
    yield put({
      type: removeNotificationsCounters.SEND,
      payload: { type: 'communities', community_ids: [communityId] },
    });
  }
  if (!isCurrentCommunity) {
    yield put({
      type: notificationCounters.UPDATE_COMMUNITY_COUNT,
      payload: 1,
    });
  }
}

export default function* joinRequestNotificationSaga() {
  yield takeEvery(chatConsts.NEW_POST, newPostNotificationWorker);
}



// WEBPACK FOOTER //
// ./src/redux/communities/sagas/newPost.js